import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import ReactPlayer from "react-player";

const VideoPlayer = ({ title, url, posterUrl }) => {
  return (
    <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h5" gutterBottom>
        {title || "Demonstration Video"}
      </Typography>
      
      <Box 
        sx={{ 
          position: 'relative', 
          paddingTop: '56.25%', // 16:9 aspect ratio
          width: '100%',
          backgroundColor: '#000',
          '& > div': {
            position: 'absolute',
            top: 0,
            left: 0,
          }
        }}
      >
        <ReactPlayer
          url={url}
          controls={true}
          width="100%"
          height="100%"
          style={{ position: 'absolute', top: 0, left: 0 }}
          config={{
            file: {
              attributes: {
                poster: posterUrl,
                controlsList: "nodownload",
              },
            },
          }}
          light={posterUrl}
        />
      </Box>
      
      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
        This video demonstrates how to use the application to encrypt images and upload them to IPFS.
      </Typography>
    </Paper>
  );
};

export default VideoPlayer;